import { DistribuicaoLimitesService } from '../distribuicao-limites.service';
import { Component, OnInit } from "@angular/core";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AmbienteService } from 'src/app/shared/services/ambiente-service';
import { lastValueFrom, Observable } from 'rxjs';
import { ApuracaoRenunciaDto } from 'src/app/model/renuncia.model';
import { CicloDistribuicaoDto } from 'src/app/model/ciclo-distribuicao-dto.model';
import { ActivatedRoute } from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";

@Component({
    selector: 'app-distribuicao-limites',
    templateUrl: './distribuicao-limites.component.html',
    styleUrls: ['./distribuicao-limites.component.scss'],
    standalone: false
})
export class DistribuicaoLimitesComponent implements OnInit {

  public valorTotalNovoLimiteContratacao: number;
  public timeStamp: Date = new Date();
  public ambientePrd$:Observable<boolean>;
  public apuracaoRenunciaDto: ApuracaoRenunciaDto;
  public novoValor: number;
  public ciclos: CicloDistribuicaoDto[] = [];
  public reversaoCicloDistribuicao: boolean = false;
  public carregandoCiclos = false;


  constructor(private service: DistribuicaoLimitesService,
              private alertService: BnAlertsService,
              private loadingService: BnLoadingService,
              private ambienteService: AmbienteService,
              private activatedRoute: ActivatedRoute,) {
    const features = this.activatedRoute.snapshot.data['features']; //resolver
    this.reversaoCicloDistribuicao = features['reversaoCicloDistribuicao'] === "true"
  }

  ngOnInit(): void {
    this.ambientePrd$ = this.ambienteService.isPRD();
    this.carregarApuracao();
    this.carregarCiclos();
  }

  public executarPrevia() {
    const date = new Date(this.timeStamp).toLocaleDateString()
    if (this.valorTotalNovoLimiteContratacao <= 1.00) {
      this.alertService.alertaErro('Erro', 'O valor do novo limite precisa ser superior à 1,00');
    } else {
        this.loadingService.bloqueiaTela();
        this.service.executarPreviaDistribuicaoLimites(this.valorTotalNovoLimiteContratacao).subscribe((resp) => {
        this.alertService.alertaSucesso('Sucesso', resp.mensagem);
        this.loadingService.liberaTela();
      }, (error) => {
        this.loadingService.liberaTela();
        console.error(error)
      })
    }
  }

  public executarDistribuicao() {
    this.loadingService.bloqueiaTela();
    this.service.executarDistribuicaoLimites().subscribe({
      next: (resp) => {
        this.alertService.alertaSucesso('Sucesso', resp.mensagem);
        this.loadingService.liberaTela();
      },
      error: (error) => {
        this.loadingService.liberaTela();
      }
    });
  }

  public cadastrarCiclo1() {
    this.loadingService.bloqueiaTela();
    this.service.iniciarPrimeiroCicloDistribuicaoLimites().subscribe({
      next: (resp) => {
        this.alertService.alertaSucesso('Sucesso', resp.mensagem);
       this.loadingService.liberaTela();
      },
      error: (error) => {
        this.loadingService.liberaTela();
      }
    });
  }

  public limpar() {
    this.valorTotalNovoLimiteContratacao = null;
    this.novoValor = 0;
  }

  private carregarApuracao() {
    this.loadingService.bloqueiaTela();
    this.service.totalPorModalidade().subscribe((resp) => {
      this.apuracaoRenunciaDto = resp;
      this.loadingService.liberaTela();
    }, (error) => {
      this.loadingService.liberaTela();
    })
  }

  public atualizaValor(valorBimestre: number) {
    this.novoValor = Number(this.valorTotalNovoLimiteContratacao) + Number(valorBimestre);
  }

  public async carregarCiclos() {
    try {
      this.carregandoCiclos = true;
      const ciclosPaginados = await lastValueFrom(this.service.buscarCiclosPaginados({
        ordemAtributo: "dataFim",
        ordemSentido: "asc"
      }));
      this.ciclos = ciclosPaginados.resultados;
    } catch( err) {
      console.error(err);
    } finally {
      this.carregandoCiclos = false;
    }
  }


}
